import React from 'react';

import urlBuilder from '../../Shared/url-builder';
import { Header } from '../BettermentForAdvisors/Header';
import { Layout } from '../InstitutionalApp/Layout';

export type SettingsTab = 'firm' | 'fees' | 'integrations' | 'security';

const SETTINGS_NAV: { label: string; to: string; isExact: boolean; shouldReloadDocument?: boolean }[] = [
  { label: 'Firm details', to: urlBuilder.getSettingsFirmPage.absolute(), isExact: true },
  { label: 'Fees', to: urlBuilder.getSettingsFeesPage.absolute(), isExact: true },
  { label: 'Integrations', to: urlBuilder.getSettingsIntegrationsPage.absolute(), isExact: true },
  { label: 'Security', to: urlBuilder.getSecuritySettings(), isExact: true },
];

interface Props {
  activeTab: SettingsTab;
  children: React.ReactNode;
}

export const SettingsLayout: React.FC<Props> = ({ children }) => {
  return (
    <Layout active="settings">
      <Layout.Header>
        <Header title="Settings" navigation={SETTINGS_NAV} />
      </Layout.Header>
      <Layout.Content>{children}</Layout.Content>
    </Layout>
  );
};
